import { render, staticRenderFns } from "./sportbook-index.vue?vue&type=template&id=8ecb45d6&"
import script from "./sportbook-index.vue?vue&type=script&lang=js&"
export * from "./sportbook-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports